import ComplaintSideDrawer from './ComplaintSideDrawer'

export default ComplaintSideDrawer
